import React from "react";
import { BarChart3 } from "lucide-react";

// Balance Sheet Financial Ratios Data
const BalanceSheetRatiosData = [
  { category: "Category", values: ["2022", "2023", "2024"], bold: true, isHeader: true },
  
  // Assets Ratios
  { category: "Current Assets", values: ["43.9%", "44.8%", "45.5%"], bold: false },
  { category: "Fixed Assets", values: ["56.1%", "55.2%", "54.5%"], bold: false },
  { category: "Total Assets", values: ["100.0%", "100.0%", "100.0%"], bold: true },
  
  // Liabilities Ratios
  { category: "Current Liabilities", values: ["29.8%", "29.8%", "29.7%"], bold: false },
  { category: "Long-term Liabilities", values: ["33.3%", "33.1%", "33.3%"], bold: false },
  { category: "Total Liabilities", values: ["63.2%", "62.9%", "62.9%"], bold: true },
  
  // Equity Ratios
  { category: "Retained Earnings", values: ["17.5%", "18.4%", "19.1%"], bold: false },
  { category: "Common Stock", values: ["17.5%", "15.3%", "13.6%"], bold: false },
  { category: "Total Equity", values: ["35.1%", "33.7%", "32.7%"], bold: true },
  { category: "Total Liabilities & Equity", values: ["100.0%", "100.0%", "100.0%"], bold: true }
];

// Balance Sheet Ratios Component
const BalanceSheetRatios = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-8">
      {/* Header */}
      <div className="flex items-center space-x-2 mb-6">
        <BarChart3 className="h-6 w-6 text-blue-600" />
        <h3 className="text-lg font-medium text-gray-900">Balance Sheet Ratios</h3>
      </div>
      <p className="text-sm text-gray-600 mb-4">
        Balance Sheet Ratios (Last 3 Years) – Breakdown of assets, liabilities, and equity as percentages.
      </p>

      {/* Balance Sheet Table */}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Category</th>
              {BalanceSheetRatiosData[0].values.map((year, index) => (
                <th key={index} className="border border-gray-300 px-4 py-2 text-center font-semibold">
                  {year}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {BalanceSheetRatiosData.slice(1).map((item, index) => (
              <tr key={index} className="border-b border-gray-300">
                <td className={`border border-gray-300 px-4 py-2 ${item.bold ? "font-bold" : ""}`}>
                  {item.category}
                </td>
                {item.values.map((value, i) => (
                  <td key={i} className="border border-gray-300 px-4 py-2 text-center">
                    {value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BalanceSheetRatios;
